<template>
    <div >
      <div>
        <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"

        @refresh-change="onLoad"

      >


      </avue-crud>
      </div>

    </div>
  </template>
  <script>


  import { carparkingSpaceFeeDetailPage} from './index.js';
  export default {
    components: {  },
    props: {
      row: {
        default: {},
      },
      spaceId:{},
      model: {},
    },
    data() {
      return {
      data:[],
      page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
      option: {
          selection: false,
          select: false,
          index: true,
          indexFixed:false,
          indexLabel: '#',
          page: true,
          height: '550',
          calcHeight: 'auto',
          align: 'left',
          menu: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '缴费日期',
              prop: 'payTime',

            },
            {
              label: '收费套餐',
              prop: 'feeRuleName',


            },
            {
              label: '生效日期',
              prop: 'feeStartTime',


            },
            {
              label: '缴费时长(个月)',
              width: 120,
              prop: 'cycleNum',


            },
            {
              label: '失效日期',

              prop: 'feeEndTime',

            },
            {
              label: '应收金额',
              width: 90,
              prop: 'shouldAmount',

            },
            {
              label: '实收金额',
              width: 90,
              prop: 'payAmount',

            },
            {
              label: '收款方式',
              width: 90,
              prop: 'payTypeValue',

            },
            {
              label: '交易状态',
              width: 110,
              prop: 'tradeStatusStr',

            },
            {
              label: '收款人',

              prop: 'cashierName',

            },



          ],
        },
      };
    },
    created() {

    },
    mounted() {

    },
    watch:{

    },
    methods: {
      onLoad(){
        this.loading = true;
        carparkingSpaceFeeDetailPage({
            parkingSpaceId:this.row.id,
            current: this.page.currentPage,
            size: this.page.pageSize ,
            tradeStatus:2
        }).then(res=>{
            this.data= res.data.records
            this.page.total = res.data.total;
            this.loading = false;
        }) .catch(() => {
              this.loading = false;
            });
      }

    },
  };
  </script>
  <style scoped>

  </style>
